export default {"src":"/_next/static/media/jnt.7425fb2c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};